import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { CopyButtonProps } from "models/propTypes/copyButtonPropTypes";
//#endregion
//#region components
import StyledButton from "./styledButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const CopyButton: React.FC<CopyButtonProps> = (props) => {
  const { copyText, showCopyIcon, onClick, children, className, testId, ...rest } = props;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    navigator.clipboard.writeText(copyText);
  };

  return (
    <StyledButton
      {...rest}
      onClick={handleClick}
      className={clsx(cssExports.actionLinkButton, className)}
      testId={testId}
      endIcon={
        copyText && showCopyIcon ? (
          <Icon icon={IconDefinitionConstants.WCopy} className={cssExports.icon} />
        ) : (
          <></>
        )
      }
    >
      {children}
    </StyledButton>
  );
};

export default CopyButton;
